<template>
	<HmEntryLayout app="auth">
		<slot />
	</HmEntryLayout>
</template>
